module.exports = __webpack_public_path__ + "static/media/BF.789eedd5.svg";